import { CreateNewProjectThemeSizeConfig } from './types';

const large: CreateNewProjectThemeSizeConfig = {
  createNewProject: {},
};

export default large;
